import { SubText, TitleH2 } from 'components/Common/Typography'
import Image from 'next/image'
import React from 'react'

import { Col, Container, Row } from 'react-bootstrap'

function ProjectManagementTools() {
  return (
    <section className="Proj_management_tools pt-120px pb-120px">
      <Container>
        <Row className="justify-content-between">
          <Col xl={5} className="mb-5 mb-sm-0 mb-xl-0">
            <TitleH2
              text="Our Utilitarian Tools"
              className="mb-4 text_black"
            />
            <SubText
              className="mb-5 mb-sm-0 pt-2"
              text="Just like our adept team, we use some cutting-edge tools to deliver you the best product engineering services in the market."
            />
          </Col>
        </Row>
        <Row>
          <Col xl={12} className="">
            <div className="d-flex justify-content-lg-between flex-wrap">
              <div className="pm_tool_item my-3">
                <Image
                  src="/assets/images/product-engineering/pm_tools_img-1.png"
                  alt="img"
                  width={184}
                  height={47}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="pm_tool_item my-3">
                <Image
                  src="/assets/images/product-engineering/pm_tools_img-2.png"
                  alt="img"
                  width={177}
                  height={117}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="pm_tool_item my-3">
                <Image
                  src="/assets/images/product-engineering/pm_tools_img-3.png"
                  alt="img"
                  width={183}
                  height={103}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="pm_tool_item my-3">
                <Image
                  src="/assets/images/product-engineering/pm_tools_img-4.png"
                  alt="img"
                  width={153}
                  height={101}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
              <div className="pm_tool_item my-3">
                <Image
                  src="/assets/images/product-engineering/pm_tools_img-5.png"
                  alt="img"
                  width={150}
                  height={84}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default ProjectManagementTools
